import cookie from './cookie';

export function isReturningUser(): boolean {
  if (cookie.exists('form_key')) {
    return true;
  }

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith('ipt:')) {
      return true;
    }
  }

  return false;
}
